import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import {
  BpnConnectorDetails,
  DiscoveryApi,
  OrganizationDetails
} from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import { DiscoveryApiPort } from '../ports/discovery-api.port';
import type {
  BpnLookupResponse,
  OrganizationLookupResponse,
  OrganizationSearchResult
} from '../models/discovery.model';

@Injectable()
export class AdessoDiscoveryApiAdapter extends DiscoveryApiPort {
  private readonly api = new DiscoveryApi(inject(ADESSO_API_CONFIG));

  getConnectorByBpnl(bpnl: string): Observable<BpnLookupResponse> {
    return from(this.api.getConnectorByBpn(bpnl)).pipe(
      map((res) => toBpnLookup(res.data))
    );
  }

  getOrganizationByBpnl(bpnl: string): Observable<OrganizationLookupResponse> {
    return from(this.api.getOrganizationByBpn(bpnl)).pipe(
      map((res) => toOrgLookup(res.data))
    );
  }

  searchOrganizations(organizationName: string): Observable<OrganizationSearchResult[]> {
    return from(this.api.searchOrganizations(organizationName)).pipe(
      map((res) => (res.data ?? []).map(toOrgSearchResult))
    );
  }
}

function toBpnLookup(dto: BpnConnectorDetails): BpnLookupResponse {
  return {
    bpnl: dto.bpnl ?? '',
    protocolUrl: dto.protocolUrl ?? null,
    useCases: toArray(dto.useCases)
  };
}

function toOrgLookup(dto: OrganizationDetails): OrganizationLookupResponse {
  return {
    bpnl: dto.bpnl ?? '',
    organizationName: dto.organizationName ?? '',
    useCases: toArray(dto.useCases)
  };
}

function toOrgSearchResult(dto: OrganizationDetails): OrganizationSearchResult {
  return {
    bpnl: dto.bpnl ?? '',
    organizationName: dto.organizationName ?? '',
    useCases: toArray(dto.useCases)
  };
}

// Generator types useCases as Set<string>; at runtime axios delivers a JSON array.
// Array.from handles both shapes safely.
function toArray(set: Set<string> | undefined): string[] {
  return set ? Array.from(set) : [];
}
